export default "__VITE_ASSET__e7746c24__"